import { ListItemIcon, ListItemText, SvgIcon, useTheme } from '@mui/material';
import { MenuItem } from './styledComponents';
import AccountCog from './icons/AccountCog';
import { useAppDispatch } from 'src/store/baseHooks';
import { useRouter } from 'next/router';
import { pushNavigationStack } from 'src/store/slices/uiFlowSlice';

interface UserAccountSettingsProps {
  handleClose: (x?: any, y?: any) => void;
}

const UserAccountSettings = ({ handleClose }: UserAccountSettingsProps) => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const theme = useTheme();

  /**
   * Handles the click event.
   *
   * @param {any} e - The event object.
   * @return {void} This function does not return a value.
   */
  const handleClick = (e: any): void => {
    dispatch(pushNavigationStack(router.asPath));
    router.push(`/uiflow/account`);
    handleClose(e, 'backdropClick');
  };

  return (
    <MenuItem sx={{ paddingBlock: '10px' }} onClick={handleClick}>
      <ListItemIcon>
        <SvgIcon>
          <AccountCog productColor={theme.palette.customColors.primaryGradient} />
        </SvgIcon>
      </ListItemIcon>
      <ListItemText sx={{ '& span:hover': { color: theme.palette.customColors.primaryGradient } }}>
        Account Settings
      </ListItemText>
    </MenuItem>
  );
};

export default UserAccountSettings;
